import React, { useState, useEffect } from 'react';
import './loader.css'; // Import your CSS file for styling

const Loader = () => {
  // State to manage whether the loader is visible or not
  const [isLoading, setIsLoading] = useState(true);

  // Simulate a delay to show the loader for demonstration purposes
  useEffect(() => {
    // Simulate loading time for text
    const textLoadTimer = setTimeout(() => {
      // Simulate loading time for all items
      const loadItems = () => {
        // Simulate loading time for all items
        setTimeout(() => {
          // Assuming all items are loaded after 3 seconds
          setIsLoading(false);
        }, 3000); // Adjust the delay time as needed
      };

      // Call the function to load items
      loadItems();
    }, 2000); // Adjust the delay time as needed for the text

    // Cleanup function
    return () => {
      clearTimeout(textLoadTimer);
    };
  }, []);

  return (
    <div className={`terminal-loader ${isLoading ? '' : 'hidden'}`}>
      <div className="terminal-header">
        <div className="terminal-title">Welcome to Shanzae Zia Portfolio</div>
        <div className="terminal-controls">
          <div className="control close"></div>
          <div className="control minimize"></div>
          <div className="control maximize"></div>
        </div>
      </div>
      <div className="text">
        <p>Loading...</p>
      </div>
    </div>
  );
};

export default Loader;